(function () {
  'use strict';

  var originalAppend = HTMLElement.prototype.appendChild;

  var queuedClarity = [], clarityDone = false;
  var queuedGorgias = [], gorgiasDone = false;
  var queuedRebuy = [],   rebuyDone   = false;
  var queuedAuto = [],    autoDone    = false;

  function matchScript(node, keyword) {
    return node && node.tagName === 'SCRIPT' && node.src && node.src.indexOf(keyword) !== -1;
  }

  function flush(queue, target) {
    while (queue.length) originalAppend.call(target, queue.shift());
  }

  function releaseClarity()  { if (clarityDone) return; clarityDone = true; flush(queuedClarity, document.head); }
  function releaseGorgias()  { if (gorgiasDone) return; gorgiasDone = true; flush(queuedGorgias, document.head); }
  function releaseRebuy()    { if (rebuyDone)   return; rebuyDone   = true; flush(queuedRebuy,   document.head); }
  function releaseAuto()     { if (autoDone)    return; autoDone    = true; flush(queuedAuto,    document.head); }

  HTMLElement.prototype.appendChild = function (node) {
    if (!clarityDone && (matchScript(node, 'clarity.ms') || matchScript(node, 'clarity'))) {
      queuedClarity.push(node); return node;
    }
    if (!gorgiasDone && matchScript(node, 'gorgias')) {
      queuedGorgias.push(node); return node;
    }
    if (!rebuyDone && matchScript(node, 'rebuy')) {
      queuedRebuy.push(node); return node;
    }
    if (!autoDone && (matchScript(node, 'automizely') || matchScript(node, 'aftership'))) {
      queuedAuto.push(node); return node;
    }
    return originalAppend.call(this, node);
  };

  // Clarity: release on any interaction or idle (analytics, no urgency)
  ['click', 'touchstart', 'keydown'].forEach(function (e) {
    document.addEventListener(e, releaseClarity, { once: true, passive: true });
  });
  if ('requestIdleCallback' in window) requestIdleCallback(releaseClarity);
  else window.addEventListener('load', releaseClarity, { once: true });

  // Gorgias, Rebuy, Automizely: release on first interaction/scroll or 5s idle fallback
  [releaseGorgias, releaseRebuy, releaseAuto].forEach(function (fn) {
    ['click', 'scroll', 'touchstart', 'keydown'].forEach(function (e) {
      document.addEventListener(e, fn, { once: true, passive: true });
    });
    if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 5000 });
    else setTimeout(fn, 5000);
  });
})();
